@defer (on viewport) {
  <app-card>
    <app-card-header title="Operações" />
    <div class="w-full p-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
      <ng-container [ngTemplateOutlet]="summaryGgrDetailsOperations" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
    </div>

    <div class="w-full p-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
      <ng-container [ngTemplateOutlet]="summaryLifeCycle" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
    </div>

    <p-divider />

    <ng-container [ngTemplateOutlet]="summaryLifeCycleChurn" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>

    <p-divider />

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 xl:divide-x divide-gray-300 mt-4">
      <div class="flex-1 p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 border border-zinc-300 xl:border-none p-4 xl:p-0 rounded-lg">
          <div class="flex flex-col items-start justify-start gap-2 col-span-1 sm:col-span-2">
            <ng-container [ngTemplateOutlet]="summaryGgrDetailsDaily" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
          </div>
          <div class="flex flex-col items-start justify-start gap-2">
            <ng-container [ngTemplateOutlet]="summaryGgrDetailsWeekly" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
          </div>
          <div class="flex flex-col items-start justify-start gap-2">
            <ng-container [ngTemplateOutlet]="summaryGgrDetailsMonthly" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
          </div>
        </div>
      </div>

      <div class="flex-1 p-4">
        <div class="w-full h-68 xl:h-52 border border-zinc-300 xl:border-none p-4 xl:p-0 rounded-lg">
          <ng-container [ngTemplateOutlet]="summaryTurnover" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-8">
          <div class="space-y-2">
            <ng-container [ngTemplateOutlet]="topCasinoGamesTop5" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
          </div>
          <div class="space-y-2">
            <ng-container [ngTemplateOutlet]="topSportsMarketsTop5" [ngTemplateOutletContext]="{ inDialog: false }"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </app-card>
} @placeholder {
  <app-card>
    <div class="w-full grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
      @for (item of [0,1,2,3,4,5,6,7,8,9,10]; track item) {
        <p-skeleton height="6rem" />
      }
    </div>
    <div class="w-full p-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-4">
      @for (item of [0,1,2,3,4,5]; track item) {
        <p-skeleton height="5rem" />
      }
    </div>
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="col-span-2">
          <p-skeleton height="14rem" />
        </div>
        <p-skeleton height="13rem" />
        <p-skeleton height="13rem" />
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="col-span-2">
          <p-skeleton height="14rem" />
        </div>
        <p-skeleton height="13rem" />
        <p-skeleton height="13rem" />
      </div>
    </div>
  </app-card>
}

<p-dialog
  [(visible)]="dialogVisible"
  [maximizable]="true"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '60rem', minHeight: '32rem' }"
>
  <ng-template pTemplate="header">
    <div class="text-zinc-900 text-xl font-semibold">{{ dialogTitle() }}</div>
  </ng-template>
  <ng-container
    [ngTemplateOutlet]="selectedDialogChart()"
    [ngTemplateOutletContext]="{ inDialog: true }"
  ></ng-container>
</p-dialog>

<p-dialog
  [(visible)]="churnDialogVisible"
  [maximizable]="true"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '80rem' }"
>
  <ng-template pTemplate="header">
    <div class="w-full flex items-center justify-between gap-4">
      <div class="text-zinc-900 text-xl font-semibold">Churn Detalhes</div>
      <div>
        <div class="flex items-center justify-end gap-4 pr-8">
          <p-autocomplete
            id="utm_source_daily"
            [(ngModel)]="summaryChurnDetailedUtm"
            [suggestions]="summaryChurnUtmFilter()"
            size="small"
            placeholder="UTM Source"
            (completeMethod)="filterUtmMethodCompleteMethod($event)"
            [showClear]="true"
            appendTo="body"
          />
          <i
            class="text-xl fa-solid fa-magnifying-glass cursor-pointer"
            pTooltip="Filtrar Detalhes de Churn"
            (click)="getSummaryChurnDetailed()"
          ></i>
        </div>
      </div>
    </div>
  </ng-template>
  <p-table
    [value]="summaryChurnDetailedData()?.items || []"
  >
    <ng-template #header>
      <tr>
        <th class="text-sm px-1">UTM Source</th>
        <th class="text-sm text-right px-1">Qtd Jogadores</th>
        <th class="text-sm text-right px-1">Depósitos</th>
        <th class="text-sm text-right px-1">Apostas</th>
        <th class="text-sm text-right px-1">Premios</th>
        <th class="text-sm text-right px-1">GGR</th>
        <th class="text-sm text-right px-1">Churn %</th>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      @if (summaryChurnDetailedLoading()) {
      <tr>
        <td colspan="7" class="text-center">
          <div class="h-68 flex items-center justify-center">
            <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
          </div>
        </td>
      </tr>
      } @else {
        <tr>
          <td colspan="7" class="text-center">
            <div class="h-68 p-4 text-zinc-500">
              Nenhum registro encontrado.
            </div>
          </td>
        </tr>
      }
    </ng-template>

    <ng-template #body let-item>
      <tr>
        <td class="px-1 py-1 text-sm">{{ item?.utm_source || '' }}</td>
        <td class="px-1 py-1 text-sm text-right">{{ item?.qtd_jogadores }}</td>
        <td class="px-1 py-1 text-sm text-right">{{ item?.total_depositos | currency }}</td>
        <td class="px-1 py-1 text-sm text-right">{{ item?.total_apostas | currency }}</td>
        <td class="px-1 py-1 text-sm text-right">{{ item?.total_premios | currency }}</td>
        <td class="px-1 py-1 text-sm text-right">{{ item?.total_ggr | currency }}</td>
        <td class="px-1 py-1 text-sm text-right">{{ item?.churn_percentage }}%</td>
      </tr>
    </ng-template>

    <ng-template #footer>
      <tr>
        <td colspan="7">
            <div class="w-full flex justify-end">
              <p-paginator
                (onPageChange)="onPageChange($event)"
                [rows]="summaryChurnPageControl.take"
                [totalRecords]="summaryChurnPageControl.itemCount"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                appendTo="body"
              />
            </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<ng-template #summaryGgrDetailsOperations let-inDialog="inDialog">
  @if (summaryGgrDetailsOperationsLoading()) {
    @for (i of [1,2,3,4,5,6,7,8]; track i) {
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <p-skeleton width="4rem" />
        <p-skeleton width="12rem" height="1.5rem" />
        <p-skeleton width="14rem" />
      </div>
    }
  }
  @else {
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">Apostas</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.apostas?.value || 0) | currency }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.apostas?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.apostas?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.apostas?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.apostas?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.apostas?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">Prêmios</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.premios?.value || 0) | currency }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.premios?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.premios?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.premios?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.premios?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.premios?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">GGR</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.ggr?.value || 0) | currency }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.ggr?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.ggr?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.ggr?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.ggr?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.ggr?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">Depósitos</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.depositos?.value || 0) | currency }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.depositos?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.depositos?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.depositos?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.depositos?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.depositos?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">FTDs</div>
      <div class="grid grid-cols-3 gap-2">
        <div class="flex flex-col">
          <span class="text-xs text-zinc-400">Valor</span>
          <span class="text-base text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.ftds?.value || 0) | currency:'BRL':'symbol':'1.0-0' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-xs text-zinc-400">Qtd</span>
          <span class="text-base text-zinc-900 font-semibold">{{ summaryGgrDetailsOperationsData()?.ftds?.qty_ftds || 0 }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-xs text-zinc-400">Média</span>
          <span class="text-base text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.ftds?.avg_ftd_value || 0) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.ftds?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.ftds?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.ftds?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.ftds?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.ftds?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">Usuários Ativos</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ summaryGgrDetailsOperationsData()?.usuarios_ativos?.value || 0 }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.usuarios_ativos?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.usuarios_ativos?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.usuarios_ativos?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.usuarios_ativos?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.usuarios_ativos?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">Aposta Média</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.aposta_media?.value || 0) | currency }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.aposta_media?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.aposta_media?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.aposta_media?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.aposta_media?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.aposta_media?.variation }}%</span>
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">Caixa Líquido</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (summaryGgrDetailsOperationsData()?.caixa_liquido?.value || 0) | currency }}</div>
      <div class="text-sm text-zinc-500">
        @if ((summaryGgrDetailsOperationsData()?.caixa_liquido?.variation || 0) > 0) {
          <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
        } @else if ((summaryGgrDetailsOperationsData()?.caixa_liquido?.variation || 0) < 0) {
          <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
        }
        <span [ngClass]="{
          'text-emerald-600': (summaryGgrDetailsOperationsData()?.caixa_liquido?.variation || 0) > 0,
          'text-rose-600': (summaryGgrDetailsOperationsData()?.caixa_liquido?.variation || 0) < 0
        }">{{ summaryGgrDetailsOperationsData()?.caixa_liquido?.variation }}%</span>
      </div>
    </div>
  }
</ng-template>

<ng-template #summaryLifeCycle let-inDialog="inDialog">
  @if (summaryLifeCycleLoading()) {
    @for (i of [1,2,3]; track i) {
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <p-skeleton width="4rem" />
        <p-skeleton width="12rem" height="1.5rem" />
        <p-skeleton width="14rem" />
      </div>
    }
  }
  @else {
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">{{ financialLifeCycleItemCategory.ATIVO_REGULAR | financialLifecycleCategory }}</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (getSummaryLifeCycleDataByEnum(financialLifeCycleItemCategory.ATIVO_REGULAR)?.valor_total) | currency }}</div>
      <div class="text-sm text-zinc-500">
        Jogadores: {{ getSummaryLifeCycleDataByEnum(financialLifeCycleItemCategory.ATIVO_REGULAR)?.qtd_jogadores }}
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">{{ financialLifeCycleItemCategory.REATIVACAO | financialLifecycleCategory }}</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (getSummaryLifeCycleDataByEnum(financialLifeCycleItemCategory.REATIVACAO)?.valor_total) | currency }}</div>
      <div class="text-sm text-zinc-500">
        Jogadores: {{ getSummaryLifeCycleDataByEnum(financialLifeCycleItemCategory.REATIVACAO)?.qtd_jogadores }}
      </div>
    </div>
    <div class="border-b border-zinc-300 space-y-2 pb-2">
      <div class="text-sm text-zinc-500">{{ financialLifeCycleItemCategory.NOVO_APOSTADOR | financialLifecycleCategory }}</div>
      <div class="text-xl text-zinc-900 font-semibold">{{ (getSummaryLifeCycleDataByEnum(financialLifeCycleItemCategory.NOVO_APOSTADOR)?.valor_total) | currency }}</div>
      <div class="text-sm text-zinc-500">
        Jogadores: {{ getSummaryLifeCycleDataByEnum(financialLifeCycleItemCategory.NOVO_APOSTADOR)?.qtd_jogadores }}
      </div>
    </div>
  }
</ng-template>

<ng-template #summaryLifeCycleChurn let-inDialog="inDialog">
  @if (summaryChurnLoading()) {
    <div class="w-full px-4">
      <p-skeleton width="20rem" height="1.5rem" />
    </div>
    <div class="w-full p-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-4">
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <div class="border-b border-zinc-300 space-y-2 pb-2">
          <p-skeleton width="4rem" />
          <p-skeleton width="10rem" height="1.5rem" />
        </div>
      }
    </div>
  }
  @else {
    <div class="flex items-center justify-start flex-wrap gap-4 px-4">
      <div class="text-xl font-semibold text-zinc-900">Churn</div>
      <div class="text-lg text-zinc-900">
        {{ summaryChurnData()?.churn?.periodo_referencia?.mes }}
      </div>
      <div>
        <p-selectbutton
          [options]="[ summaryChurnType.BETS, summaryChurnType.CHARGE ]"
          [(ngModel)]="summaryChurnShowType"
          (ngModelChange)="getSummaryChurn()"
          size="small"
        >
          <ng-template let-type #item>
            <div>{{ type | financialChurnType }}</div>
          </ng-template>
        </p-selectbutton>
      </div>
      <i class="text-xl fa-solid fa-sitemap cursor-pointer" pTooltip="Detalhes do Churn" (click)="openChurnDialog()"></i>
    </div>
    <div class="w-full p-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-4">
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <div class="text-sm text-zinc-500">Jogadores</div>
        <div class="text-xl text-zinc-900 font-semibold">{{ summaryChurnData()?.churn?.total?.qtd_jogadores }}</div>
      </div>
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <div class="text-sm text-zinc-500">Depósitos</div>
        <div class="text-xl text-zinc-900 font-semibold">{{ summaryChurnData()?.churn?.total?.total_depositos | currency }}</div>
      </div>
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <div class="text-sm text-zinc-500">Apostas</div>
        <div class="text-xl text-zinc-900 font-semibold">{{ summaryChurnData()?.churn?.total?.total_apostas | currency }}</div>
      </div>
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <div class="text-sm text-zinc-500">Premios</div>
        <div class="text-xl text-zinc-900 font-semibold">{{ summaryChurnData()?.churn?.total?.total_premios | currency }}</div>
      </div>
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <div class="text-sm text-zinc-500">GGR</div>
        <div class="text-xl text-zinc-900 font-semibold">{{ summaryChurnData()?.churn?.total?.total_ggr | currency }}</div>
      </div>
      <div class="border-b border-zinc-300 space-y-2 pb-2">
        <div class="text-sm text-zinc-500">Churn %</div>
        <div class="text-xl text-zinc-900 font-semibold">{{ summaryChurnData()?.churn?.total?.churn_percentage }}%</div>
      </div>
    </div>
  }
</ng-template>

<ng-template #summaryGgrDetailsDaily let-inDialog="inDialog">
  <div class="w-full flex flex-wrap items-center justify-between">
    <div class="text-sm text-zinc-500">Diário</div>
    <div>
      @if (!inDialog) {
        <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(summaryGgrDetailsDaily, 'Diário')"></i>
      }
    </div>
  </div>
  <div class="w-full items-center justify-center">
    @if (summaryGgrDetailsDailyLoading() && !summaryGgrDetailsDailyChartData()) {
      <div class="w-full h-48 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (summaryGgrDetailsDailyChartData()?.datasets.length) {
      <p-chart
        type="bar"
        id="summaryGgrDetailsDailyChart"
        #summaryGgrDetailsDailyChart
        [data]="summaryGgrDetailsDailyChartData()"
        [options]="summaryGgrDetailsDailyOptions()"
        class="w-full"
        [ngClass]="{ 'h-100': inDialog, 'h-48': !inDialog }"
      />
    } @else {
      <app-empty-chart />
    }
  </div>
</ng-template>

<ng-template #summaryGgrDetailsWeekly let-inDialog="inDialog">
  <div class="w-full flex flex-wrap items-center justify-between">
    <div class="text-sm text-zinc-500">Semanal</div>
    <div>
      @if (!inDialog) {
        <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(summaryGgrDetailsWeekly, 'Semanal')"></i>
      }
    </div>
  </div>
  <div class="w-full items-center justify-center">
    @if (summaryGgrDetailsWeeklyLoading() && !summaryGgrDetailsWeeklyChartData()) {
      <div class="w-full h-48 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (summaryGgrDetailsWeeklyChartData()?.datasets.length) {
      <p-chart
        type="bar"
        id="summaryGgrDetailsWeeklyChart"
        #summaryGgrDetailsWeeklyChart
        [data]="summaryGgrDetailsWeeklyChartData()"
        [options]="summaryGgrDetailsWeeklyOptions()"
        class="w-full"
        [ngClass]="{ 'h-100': inDialog, 'h-48': !inDialog }"
      />
    } @else {
      <app-empty-chart />
    }
  </div>
</ng-template>

<ng-template #summaryGgrDetailsMonthly let-inDialog="inDialog">
  <div class="w-full flex flex-wrap items-center justify-between">
    <div class="text-sm text-zinc-500">Mensal</div>
    <div>
      @if (!inDialog) {
        <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(summaryGgrDetailsMonthly, 'Mensal')"></i>
      }
    </div>
  </div>
  <div class="w-full items-center justify-center">
    @if (summaryGgrDetailsMonthlyLoading() && !summaryGgrDetailsMonthlyChartData()) {
      <div class="w-full h-48 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (summaryGgrDetailsMonthlyChartData()?.datasets.length) {
      <p-chart
        type="bar"
        id="summaryGgrDetailsMonthlyChart"
        #summaryGgrDetailsMonthlyChart
        [data]="summaryGgrDetailsMonthlyChartData()"
        [options]="summaryGgrDetailsMonthlyOptions()"
        class="w-full"
        [ngClass]="{ 'h-100': inDialog, 'h-48': !inDialog }"
      />
    } @else {
      <app-empty-chart />
    }
  </div>
</ng-template>

<ng-template #summaryTurnover let-inDialog="inDialog">
  <div class="w-full flex flex-wrap items-center justify-between">
    <div class="text-sm text-zinc-500">Turnover</div>
    <div class="flex items-center justify-end gap-2">
      @if (!inDialog) {
        <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(summaryTurnover, 'Turnover')"></i>
      }
    </div>
  </div>
  <div class="w-full h-full flex flex-col items-center justify-center">
    @if (summaryTurnoverLoading() && !summaryTurnoverChartData()) {
      <div class="w-full h-96 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (summaryTurnoverChartData()?.datasets.length) {
        <p-chart
          id="summaryTurnoverChart"
          #summaryTurnoverChart
          type="line"
          [data]="summaryTurnoverChartData()"
          [options]="summaryTurnoverOptions()"
        class="w-full"
        [ngClass]="{ 'h-100': inDialog, 'h-52': !inDialog }"
        />
    } @else {
      <app-empty-chart />
    }
  </div>
</ng-template>

<ng-template #topCasinoGamesTop5 let-inDialog="inDialog">
  <div class="text-sm text-zinc-500">Top 5 Jogos</div>
  <p-table
    [value]="topCasinoGamesTop5Data()?.top_5_games || []"
  >
    <ng-template #header>
      <tr>
        <th class="text-sm px-1">Nome</th>
        <th class="text-sm px-1">Turnover</th>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      @if (topCasinoGamesTop5Loading()) {
      <tr>
        <td colspan="2" class="text-center">
          <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
        </td>
      </tr>
      } @else {
        <tr>
          <td colspan="2" class="text-center">
            <div class="h-44 p-4 text-zinc-500">
              Nenhum registro encontrado.
            </div>
          </td>
        </tr>
      }
    </ng-template>

    <ng-template #body let-item>
      <tr>
        <td class="px-1 py-1 text-sm">{{ item?.game_name || '---' }}</td>
        <td class="px-1 py-1 text-sm">{{ item?.total_bet_amount | currency }}</td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<ng-template #topSportsMarketsTop5 let-inDialog="inDialog">
  <div class="text-sm text-zinc-500">Top 5 Mercados</div>
  <p-table
    [value]="topSportsMarketsTop5Data()?.top_5_markets || []"
  >
    <ng-template #header>
      <tr>
        <th class="text-sm px-1">Nome</th>
        <th class="text-sm px-1">Turnover</th>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      @if (topSportsMarketsTop5Loading()) {
      <tr>
        <td colspan="2" class="text-center">
          <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
        </td>
      </tr>
      } @else {
        <tr>
          <td colspan="2" class="text-center">
            <div class="h-44 p-4 text-zinc-500">
              Nenhum registro encontrado.
            </div>
          </td>
        </tr>
      }
    </ng-template>

    <ng-template #body let-item>
      <tr>
        <td class="px-1 py-1 text-sm">{{ item?.market_name || '---' }}</td>
        <td class="px-1 py-1 text-sm">{{ item?.total_bet_value | currency }}</td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>
